<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import {
  genderFilter,
  findDistrictZip,
  districtsFilter,
  taiwanCitys,
  taxTypeMap,
  carrierTypeMap,
} from '@utils/filter-value-to-text'

const extraInfoPhone = {
  phoneCode: '+886',
  phoneNumber: ''
}

const extraInfoEmergency = {
  phoneCode: '+886',
  phoneNumber: '',
  fullName: '',
  gender: 'male'
}

const initData = () => {
  return {
    fullName:'',
    gender:'male',
    phone:'',
    phoneCode:'+886',
    phoneNumber:'',
    tags:[],
    email:'',
    lineId:'',
    merchantNote:'',
    extraInfos: {
      extraInfoPhone: [extraInfoPhone],
      extraInfoEmergency: [extraInfoEmergency]
    }
  }
}

const defaultAddress = () => {
  return {
    address: '',
    city: '',
    district: '',
    email: '',
    name: '',
    phone: '',
    postcode: '',
  }
}

export default {
  components: {
    MemberForm: () => lazyLoadComponent(import('./MemberForm')),
    InvoiceForm: () => lazyLoadComponent(import('@components/InvoiceForm')),
    Note: () => lazyLoadComponent(import('@components/Note')),
    MemberOrdersProduct: () => lazyLoadComponent(import('./MemberOrdersProduct')),
    MemberOrdersPrepaid: () => lazyLoadComponent(import('./MemberOrdersPrepaid')),
    MemberOrdersDespoit: () => lazyLoadComponent(import('./MemberOrdersDespoit')),
  },
  filters: {
    genderFilter
  },
  props: {
    memberInfo: {
      type: Object,
      default: () => {}
    },
    memberInfoActiveTab: {
      type: String,
      default: 'information',
      validator(value) {
        return [
          'information',
          'orders',
          'note',
        ].includes(value)
      },
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false
    } 
  },
  data() {
    return {
      taiwanCitys,
      taxTypeMap,
      carrierTypeMap,
      submitData: Object.assign({}, initData()),
      tryingStoreMember: false,
      editBasicInfoEnabled: false,
      editInvoiceEnabled: false,
      // 地址
      addressMode: 'billing',
      visibleDialogAddress: false,
      tryingSaveAddress: false,
      memberOrderType:'prepaid-order',
      activeTab: this.memberInfoActiveTab || 'information'
    }
  },
  mounted(){
  },
  computed: {
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      return {
        fullName: [{
          required: true,
          message: '請輸入姓名'
        }],
        phone: [{
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        gender: [{
          required: true,
          message: '請選擇性別',
          // trigger: 'change',
        }, ],
        email: [

          {
            type: 'email',
            message: '請輸入正確的 Email 格式'
          },
        ],
      }
    },
    addressRules() {
      return {
        'shippingInfo.0.phone': [
          // { required: true, message: '請輸入電話',trigger: 'blur' },
          {
            pattern: /[\s\#0-9_\-\+\/\(\)\.]/,
            message: '請輸入正確的 電話 格式',
            trigger: 'blur',
          },
        ],
        'billingInfo.phone': [
          // { required: true, message: '請輸入電話',trigger: 'blur' },
          {
            pattern: /[\s\#0-9_\-\+\/\(\)\.]/,
            message: '請輸入正確的 電話 格式',
            trigger: 'blur',
          },
        ],
      }
    },
    districts() {
      let districts = []
      if (this.addressMode === 'shipping') {
        districts = this.submitData[`${this.addressMode}Info`][0].city
      }
      if (this.addressMode === 'billing') {
        districts = this.submitData[`${this.addressMode}Info`].city
      }
      return districtsFilter(districts)
    },
    visibleInvoice() {
      return this.memberInfo.storeInvoiceSetting === 1
    },
    depositReduce(){
      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    filteredSubmitData() {
      const { tags, phone, CarrierType, CarrierNum, ...data } = this.submitData
      const tagIds = tags.map(item => item.id)
      return {
        ...data,
        tagIds,
        phone,
        CarrierType,
        CarrierNum: CarrierType === '2' ? phone : CarrierNum,
      }
    }
  },
  watch: {
    memberInfo: {
      handler(val) {
        this.submitData = cloneDeep({
          ...val,
          phone: val.phoneNumber,
          merchantNote: val.merchantNote?.replace(/<br\s\/>/g, ''),
          extraInfos: val.extraInfos 
          ?? {
            extraInfoPhone: [extraInfoPhone],
            extraInfoEmergency: [extraInfoEmergency]
          }
        })
      },
      immediate: true,
    },
    'memberInfoActiveTab': {
      immediate: true, 
      handler (val, oldVal) {
        this.activeTab = val
      }
    }
  },
  methods: {
    async tryToStoreMember() {
      // await this.$refs.form.validate()
      this.tryingStoreMember = true
      try {
        const { items = {} } = await this.$store.dispatch('member/store', this.filteredSubmitData)
        const memberId = items.id
        this.updateMemberInfoView(memberId)
        this.$message({ message: '儲存成功', type: 'success' })
      } finally {
        this.tryingStoreMember = false
      }
    },
    onClickEditBasicInfo() {
      this.editBasicInfoEnabled = true
    },
    enableEditAddress(mode) {
      this.addressMode = mode
      this.visibleDialogAddress = true
    },
    onSelectCity() {
      if (this.addressMode === 'billing') {
        this.submitData[`${this.addressMode}Info`] = {
          ...this.submitData[`${this.addressMode}Info`],
          district: '',
          postcode: '',
        }
      }
      if (this.addressMode === 'shipping') {
        this.submitData[`${this.addressMode}Info`][0].district = ''
        this.submitData[`${this.addressMode}Info`][0].postcode = ''
      }
    },
    onSelectDistrict() {
      if (this.addressMode === 'shipping') {
        const {
          city,
          district
        } = this.submitData[`${this.addressMode}Info`][0]
        this.submitData[`${this.addressMode}Info`][0].postcode = findDistrictZip(city, district)
      }
      if (this.addressMode === 'billing') {
        const {
          city,
          district
        } = this.submitData[`${this.addressMode}Info`]
        this.submitData[`${this.addressMode}Info`].postcode = findDistrictZip(city, district)
      }
    },
    async onClickStoreAddress() {
      await this.$refs.addressForm.validate()
      try {
        this.tryingSaveAddress = true
        await this.tryToStoreMember()
        this.visibleDialogAddress = false
      } finally {
        this.tryingSaveAddress = false
      }
    },
    handleCloseAddress() {
      this.submitData = cloneDeep(this.memberInfo)
      this.getDefaultAddress()
      this.visibleDialogAddress = false
    },
    getDefaultAddress() {
      if (this.$hasHomeService()) {
        if (!this.submitData.billingInfo) {
          this.submitData.billingInfo = defaultAddress()
        }
        if (!this.submitData.shippingInfo) {
          this.submitData.shippingInfo = [defaultAddress()]
        }
      }
    },
    enableEditInvoice() {
      this.editInvoiceEnabled = true
    },
    cancelEditInvoice() {
      const {
        taxType,
        taxId,
        CarrierType,
        CarrierNum,
        LoveCode
      } = this.memberInfo
      this.submitData = {
        ...this.submitData,
        taxType,
        taxId,
        CarrierType,
        CarrierNum,
        LoveCode,
      }
      this.editInvoiceEnabled = false
    },
    onSelectMemberOrderType(type){
      this.memberOrderType = type
    },
    updateMemberInfoView(memberId) {
      this.$emit('update', memberId || this.memberInfo.id)
      this.cancelEditInvoice()
      this.onClickCloseMemberForm()
    },
    onClickCloseMemberForm() {
      this.editBasicInfoEnabled = false
    },
    onClickClose() {
      this.$emit('close')
    },
    updateComment(type) {
      if(type === 'member_private') {
        this.updateMemberInfoView(this.memberInfo.id)
      } else if (type === 'pet') {

      } else {

      }
    }
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <template v-if="editBasicInfoEnabled">
      <MemberForm :default-value="memberInfo" @update="updateMemberInfoView" @close="onClickCloseMemberForm"/>
    </template>
    <template v-else>
      <div class="orderformSection__right__header">
        <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        <el-tabs v-model="activeTab" stretch class="isStyleBaseTab">
          <el-tab-pane label="會員資訊" name="information"> </el-tab-pane>
          <el-tab-pane label="消費記錄" name="orders"> </el-tab-pane>
          <el-tab-pane label="客戶備註" name="note"> </el-tab-pane>
        </el-tabs>
      </div>
      <div class="orderformSection__right__content">
        <div v-if="activeTab === 'information'">
          <h4 class="form-block-title">
            基本資料
            <el-button  v-if="!isEmployee" type="text" size="mini" @click="onClickEditBasicInfo">
              <BaseIcon name="edit" class="text-primary fs-xl align-text-top"/>
              <span>編輯資訊</span>
            </el-button>
          </h4>
          <ul :class="$style.detail">
            <li>姓名：<span class="text-secondary">{{ memberInfo.fullName }} {{ memberInfo.gender | genderFilter }}</span></li>
            <li>聯絡電話：<span class="text-secondary">{{ `${memberInfo.phoneCode} ${memberInfo.phoneNumber}` }}</span></li>
            <li v-if="memberInfo.extraInfos && memberInfo.extraInfos.extraInfoPhone && memberInfo.extraInfos.extraInfoPhone.length && memberInfo.extraInfos.extraInfoPhone[0].phoneNumber">
              備用電話：
              <span class="text-secondary">{{ `${memberInfo.extraInfos.extraInfoPhone[0].phoneCode} ${memberInfo.extraInfos.extraInfoPhone[0].phoneNumber}` }}</span>
            </li>
            <li v-if="memberInfo.extraInfos && memberInfo.extraInfos.extraInfoEmergency && memberInfo.extraInfos.extraInfoEmergency.length && memberInfo.extraInfos.extraInfoEmergency[0].fullName">
              緊急聯絡人姓名：
              <span class="text-secondary">{{ memberInfo.extraInfos.extraInfoEmergency[0].fullName }} {{ memberInfo.extraInfos.extraInfoEmergency[0].gender | genderFilter }}</span>
            </li>
            <li v-if="memberInfo.extraInfos && memberInfo.extraInfos.extraInfoEmergency && memberInfo.extraInfos.extraInfoEmergency.length && memberInfo.extraInfos.extraInfoEmergency[0].phoneNumber">
              緊急聯絡人電話：
              <span class="text-secondary">{{ `${memberInfo.extraInfos.extraInfoEmergency[0].phoneCode} ${memberInfo.extraInfos.extraInfoEmergency[0].phoneNumber}` }}</span>
            </li>
           
            <li>LINE ID：<span class="text-secondary">{{ memberInfo.lineId }}</span></li>
            <li>電子信箱：<span class="text-secondary">{{ memberInfo.email }}</span></li>
            <li class="tagList">
              標籤：
              <el-tag v-for="tag in memberInfo.tags" :key="`tag-${tag.id}`" class="isStyleTag" disable-transitions>
                {{ tag.title }}
              </el-tag>
            </li>
            <template v-if="$hasHomeService()">
              <li>
                帳單地址：
                <template v-if="Object.keys(memberInfo.billingInfo).length"> <span class="text-secondary">{{ memberInfo.billingInfo.city }}{{ memberInfo.billingInfo.district }}{{ memberInfo.billingInfo.address }}</span> </template>
                <el-button v-if="!isEmployee" type="text" class="isPrimary ml-2 fs-xl" size="mini" @click="enableEditAddress('billing')">
                  <BaseIcon name="edit" />
                </el-button>
              </li>
              <li>
                地址：
                <template v-if="memberInfo.shippingInfo && memberInfo.shippingInfo.length"> <span class="text-secondary">{{ memberInfo.shippingInfo[0].city }}{{ memberInfo.shippingInfo[0].district }}{{ memberInfo.shippingInfo[0].address }}</span> </template>
                <el-button v-if="!isEmployee" type="text" class="isPrimary ml-2 fs-xl" size="mini" @click="enableEditAddress('shipping')">
                  <BaseIcon name="edit" />
                </el-button>
              </li>
            </template>
          </ul>
          <el-dialog :title="`編輯${addressMode === 'billing' ? '帳單' : ''}地址`" :visible.sync="visibleDialogAddress" top="0" width="680px" append-to-body @close="handleCloseAddress">
            <template v-if="$hasHomeService() && submitData[`${addressMode}Info`]">
              <el-form ref="addressForm" :model="submitData" :rules="addressRules" label-position="top" class="el-form--floating" style="margin-top: 30px">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="姓名">
                      <el-input v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].name"></el-input>
                      <el-input v-else v-model="submitData[`${addressMode}Info`].name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item v-if="addressMode === 'shipping'" label="電話" prop="shippingInfo.0.phone">
                      <el-input v-model="submitData[`${addressMode}Info`][0].phone"></el-input>
                    </el-form-item>
                    <el-form-item v-else label="電話" prop="billingInfo.phone">
                      <el-input v-model="submitData[`${addressMode}Info`].phone"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item v-if="addressMode === 'billing'" label="電子郵件">
                  <el-input v-model="submitData[`${addressMode}Info`].email"></el-input>
                </el-form-item>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="縣市">
                      <el-select v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].city" placeholder="請選擇縣市" filterable @change="onSelectCity">
                        <el-option v-for="(city, index) in taiwanCitys" :key="`billing-city-${index}`" :label="city.name" :value="city.name"> </el-option>
                      </el-select>
                      <el-select v-else v-model="submitData[`${addressMode}Info`].city" placeholder="請選擇縣市" filterable @change="onSelectCity">
                        <el-option v-for="(city, index) in taiwanCitys" :key="`billing-city-${index}`" :label="city.name" :value="city.name"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="鄉鎮市區">
                      <el-select v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].district" placeholder="請選擇鄉鎮市區" filterable @change="onSelectDistrict">
                        <el-option v-for="(district, index) in districts" :key="`billing-district-${index}`" :label="district.name" :value="district.name"> </el-option>
                      </el-select>
                      <el-select v-else v-model="submitData[`${addressMode}Info`].district" placeholder="請選擇鄉鎮市區" filterable @change="onSelectDistrict">
                        <el-option v-for="(district, index) in districts" :key="`billing-district-${index}`" :label="district.name" :value="district.name"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="郵政編號">
                  <el-input v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].postcode"></el-input>
                  <el-input v-else v-model="submitData[`${addressMode}Info`].postcode"></el-input>
                </el-form-item>
                <el-form-item label="詳細地址">
                  <el-input v-if="addressMode === 'shipping'" v-model="submitData[`${addressMode}Info`][0].address"></el-input>
                  <el-input v-else v-model="submitData[`${addressMode}Info`].address"></el-input>
                </el-form-item>
              </el-form>
              <div :class="$style.footer">
                <el-button class="is-round" @click="visibleDialogAddress = false">取消</el-button>
                <el-button class="is-round" :loading="tryingSaveAddress" :disabled="tryingSaveAddress" type="primary" @click="onClickStoreAddress">儲存</el-button>
              </div>
            </template>
          </el-dialog>
          
          <template v-if="visibleInvoice">
            <div class="bottom-line-box-normal"></div>
            <h4 class="form-block-title"
              >發票資訊
              <template v-if="!isEmployee">
                <template v-if="editInvoiceEnabled">
                  <div class="btn">
                    <el-button class="is-round" size="mini" @click="cancelEditInvoice">
                      <BaseIcon name="times" />
                        取消
                    </el-button>
                    <el-button class="is-round" size="mini" type="primary" :loading="tryingStoreMember" @click="tryToStoreMember">
                      <BaseIcon v-if="!tryingStoreMember" name="check" />
                      <span>儲存</span>
                    </el-button>
                  </div>
                </template>
                <el-button v-else type="text" class="" size="mini" @click="enableEditInvoice">
                  <BaseIcon name="edit" class="text-primary fs-xl align-text-top"/>
                  <span>編輯資訊</span>
                </el-button>
              </template>
            </h4>
            <ul :class="$style.detail">
              <template v-if="editInvoiceEnabled">
                <el-form
                  ref="form-invoice"
                  class="el-form-item--normal-margin el-form-item--white-bg"
                  :model="submitData"
                  :class="$style['detail-form']"
                  label-position="left"
                  label-width="100px"
                >
                  <InvoiceForm :default-value="submitData" :show-sync="false" />
                </el-form>
              </template>
              <template v-else>
                <li>開立類型：<span class="text-secondary">{{ taxTypeMap[submitData.taxType] }}</span></li>
                <template v-if="submitData.taxType === 'B2C'">
                  <li>載具類別：<span class="text-secondary">{{ carrierTypeMap[submitData.CarrierType] || '無（寄送電子發票至客戶 email）' }}</span></li>
                  <li v-if="submitData.CarrierType === '0' || submitData.CarrierType === '1'">載具編號：{{ submitData.CarrierNum }}</li>
                </template>
                <li v-else-if="submitData.taxType === 'B2B'">統一編號：<span class="text-secondary">{{ submitData.taxId }}</span></li>
                <li v-else>捐贈碼：<span class="text-secondary">{{ submitData.LoveCode }}</span></li>
              </template>
            </ul>
          </template>
        </div>
        <div v-if="activeTab === 'orders'">
          <div class="btn-group-inline" style="margin-bottom: 24px;overflow-x:scroll;">
            <el-button class="is-round isInputGroup" :class="{ isActive: memberOrderType === 'prepaid-order' }" @click="onSelectMemberOrderType('prepaid-order')">{{ $t('prepaid.BASE') }}方案</el-button>
            <el-button class="is-round isInputGroup" :class="{ isActive: memberOrderType === 'order' }" @click="onSelectMemberOrderType('order')">預約訂單</el-button>
            <el-button v-if="$hasDeposit()" class="is-round isInputGroup" :class="{ isActive: memberOrderType === 'despoit-order' }" @click="onSelectMemberOrderType('despoit-order')">點數紀錄</el-button>
          </div>
          <MemberOrdersPrepaid v-if="memberOrderType === 'prepaid-order'" :member-info-id="memberInfo.id" />
          <MemberOrdersProduct v-if="memberOrderType === 'order'" :member-info-id="memberInfo.id" />
          <MemberOrdersDespoit v-if="memberOrderType === 'despoit-order' && $hasDeposit()" :member-info-id="memberInfo.id" />
        </div>
        <div v-if="activeTab === 'note'">
          <Note 
            :default-value="memberInfo" 
            is-can-add 
            is-order 
            type="member_private"
            @update="updateComment"
          >
          </Note>
        </div>
      </div>
    </template>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }
        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;
          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }
          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }
          .el-tabs__nav-wrap::after {
            display: none;
          }
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs--top {
            margin-left: 60px;
            @include max-lg {
              margin-left: 30px;
            }
          }
        }
        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;
          @include max-lg {
            padding: 20px;
            padding-bottom: 120px;
          }
        }
      }
    }
  }
}

.detail li {
  line-height: 40px;
  &:global {
    &.tagList {
      .el-tag {
        margin-bottom: 10px;
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
}

// 地址
.footer {
  display: flex;
  :global {
    button {
      flex: 1 0 auto;
    }
  }
}

</style>